import { render } from "./CardTitular.vue?vue&type=template&id=6467e6d7&scoped=true"
import script from "./CardTitular.vue?vue&type=script&lang=js"
export * from "./CardTitular.vue?vue&type=script&lang=js"

import "./CardTitular.vue?vue&type=style&index=0&id=6467e6d7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6467e6d7"]])

export default __exports__